import type { StackProps } from '@hover/blueprint';
import React from 'react';

import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks/useHomeownerAppContext';

import { UploadPhotoSheet } from './UploadPhotoSheet';

const UploadHomeownerPhotoSheet: React.FC<StackProps> = ({ ...props }) => {
  const { setImageFileToUpload, setCurrentMenu } = useHomeownerAppContext();

  const callback = () => {
    setCurrentMenu(null);
  };

  return (
    <UploadPhotoSheet
      callback={callback}
      setImageFileToUpload={setImageFileToUpload}
      {...props}
    />
  );
};

export { UploadHomeownerPhotoSheet };
